module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone.2cc9e93c.svg";